export const TransactionLabelTextHelper = {
    getLabelText: {
        dateTransactionOn: 'Transaction Date',
        transactionSource: 'Source',
        transactionType: 'Type',
        transactionAmountBaseCurrency: 'Amount HKD',
        orderNumber: 'Order Number',
        marketplaceCode: 'Marketplace Code',
        dateOrderOn: 'Order Date',
        baseCurrencyCode: 'Base Currency',
        foreignCurrencyCode: 'Foreign Currency',
        exchangeRateForeignCurrencyToBaseCurrency: 'Exchange Rate',
        dateCalculationAt: 'Calculation Date',
        dateCreateAt: 'Create Date',
        dateModifyAt: 'Modify Date',
        dateTransactionOnFrom: 'Transaction Date From',
        dateTransactionOnTo: 'Transaction Date To',
        dateOrderOnFrom: 'Order Date From',
        dateOrderOnTo: 'Order Date To',
        action: 'Action'
    }
};
